import { useQuery } from 'hooks/useQuery/useQuery';
import { QueryKeyEnum } from 'core/global.enum';
import { QueryKeyLocalStorageEnum, WantedHistoryQueryKeysEnum } from 'context/query/queryContext/QueryContext.enum';
import { fetchServers } from 'api/servers/servers';
import { useLocaleStoreQuery } from 'hooks/useLocaleStoreQuery/useLocaleStoreQuery';
import { fetchWantedHistory } from 'api/wanted/wanted';
import { useSavedPagination } from 'hooks/useSavedPagination/useSavedPagination';

import { useWantedHistorySearchQuery } from './hooks/useWantedHistorySearchQuery';
import { WantedHistory } from './WantedHistory';

export const WantedHistoryContainer = () => {
  const {
    storedQueries: { wantedHistory: wantedHistoryQuery },
    setQuery,
  } = useLocaleStoreQuery();
  const {
    tkdSearchQuery,
    executorSearchQuery,
    ownerSearchQuery,
    setExecutorSearchQuery,
    setOwnerSearchQuery,
    setTkdSearchQuery,
    clearSearchQueries,
  } = useWantedHistorySearchQuery();

  const { page, rowsPerPage, setPage, setRowsPerPage, setPaginationCount, storedQueryWithoutPagination } =
    useSavedPagination({
      queryKey: QueryKeyLocalStorageEnum.WANTED_HISTORY,
      resetPaginationDependencyArray: [tkdSearchQuery, executorSearchQuery],
    });

  const { data: serversResponse } = useQuery([QueryKeyEnum.SERVERS], fetchServers);

  const { data: wantedHistoryResponse, isLoading } = useQuery(
    [
      QueryKeyEnum.WANTED_HISTORY,
      storedQueryWithoutPagination,
      rowsPerPage,
      page,
      tkdSearchQuery,
      executorSearchQuery,
      ownerSearchQuery,
    ],
    () => fetchWantedHistory(),
    {
      args: {
        ...storedQueryWithoutPagination,
        [WantedHistoryQueryKeysEnum.SERWER]: wantedHistoryQuery.serwer?.value,
        [WantedHistoryQueryKeysEnum.CZYTNIK]: wantedHistoryQuery.tkd?.value,
        [WantedHistoryQueryKeysEnum.QUERY]: wantedHistoryQuery.query?.value,
        [WantedHistoryQueryKeysEnum.POSIADACZ]: wantedHistoryQuery.posiadacz?.value,
        [WantedHistoryQueryKeysEnum.INFORMACJA]: wantedHistoryQuery.informacja,
        [WantedHistoryQueryKeysEnum.LIMIT]: rowsPerPage,
        [WantedHistoryQueryKeysEnum.OFFSET]: rowsPerPage * page,
      },
      onSuccess: (response) => {
        setPaginationCount(response.count);
      },
    },
  );

  const onClearWantedHistoryQuery = () => {
    setQuery(QueryKeyLocalStorageEnum.WANTED_HISTORY, {
      page,
      rowsPerPage,
    });
    clearSearchQueries();
  };

  return (
    <WantedHistory
      wantedHistoryResponse={wantedHistoryResponse}
      isLoading={isLoading}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}
      servers={serversResponse?.data || []}
      tkdSearchQuery={tkdSearchQuery}
      executorSearchQuery={executorSearchQuery}
      ownerSearchQuery={ownerSearchQuery}
      setExecutorSearchQuery={setExecutorSearchQuery}
      setOwnerSearchQuery={setOwnerSearchQuery}
      setTkdSearchQuery={setTkdSearchQuery}
      onClearWantedHistoryQuery={onClearWantedHistoryQuery}
    />
  );
};
